import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QrCode from '@/components/QrCode';
import { getUrl, getUrlDetail, watchCompanyName } from '../api/index.js';
export default {
  components: {
    QrCode: QrCode
  },
  props: {
    drawerVisible: {
      type: Boolean,
      default: false
    },
    drawerSetting: {
      type: Object,
      default: function _default() {
        return function () {
          return {};
        };
      }
    },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '查看专属链接/二维码'
    },
    size: {
      type: String,
      default: '88%'
    },
    origin: {
      type: String,
      default: 'layout' // 装修预览layout、设置-专属链接-查看editCustomer
    },
    hasTabAuth: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    jumpSet: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      customer_id: '',
      customer_account_id: '',
      customer_name_new: '',
      linkInfo: {
        login_url: '',
        account_logo: '',
        logo: '',
        mini_program_img_base64: '',
        mini_program_page: '',
        h5_login_url: ''
      },
      login_url: '',
      login_url1: '',
      login_url2: ''
    };
  },
  watch: {
    // 监听抽屉显示状态，显示时加载数据
    drawerVisible: function drawerVisible(isShow) {
      if (isShow) {
        console.log('drawerVisible => ', this.drawerVisible);
        console.log('drawerSetting => ', JSON.parse(JSON.stringify(this.drawerSetting)));
        this.handleResetData();
        if (this.origin === 'editCustomer') {
          // 设置-专属链接-查看（新接口）
          this.handleGetUrlDetail();
        } else if (this.origin === 'layout') {
          // 装修预览(旧接口)
          this.getCustomerUrl();
        }
      }
    }
  },
  methods: {
    _jumpSet: function _jumpSet() {
      this.handleCancel();
      this.jumpSet();
    },
    handleCancel: function handleCancel() {
      this.$emit('close');
    },
    handleResetData: function handleResetData() {
      this.customer_id = this.drawerSetting.customer_id;
      this.customer_account_id = this.drawerSetting.customer_account_id;
      this.customer_name_new = this.drawerSetting.customer_name;
    },
    handleGetUrlDetail: function handleGetUrlDetail() {
      var _this = this;
      var params = {
        id: this.id
      };
      getUrlDetail(params).then(function (res) {
        _this.linkInfo = res.data;
      });
    },
    getCustomerUrl: function getCustomerUrl() {
      var _this2 = this;
      var params = {
        customer_id: this.customer_id,
        customer_account_id: this.customer_account_id
      };
      getUrl(params).then(function (res) {
        _this2.linkInfo = res.data;
      });
    },
    copyNumber: function copyNumber(data) {
      var url = data;
      var oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message({
        message: '已成功复制到剪切板',
        type: 'success'
      });
      oInput.remove();
    },
    getCodeUrl: function getCodeUrl(url) {
      this.login_url = url;
    },
    getCodeUrl1: function getCodeUrl1(url) {
      this.login_url1 = url;
    },
    getCodeUrl2: function getCodeUrl2(url) {
      this.login_url2 = url;
    },
    downImg: function downImg(url, type) {
      var a = document.createElement('a'); //自定义a标签
      var event = new MouseEvent('click'); //自定义鼠标点击事件
      a.download = "".concat(this.customer_name_new).concat(this.customer_name_new ? ',' : '').concat(type, ".png");
      a.href = url;
      a.dispatchEvent(event);
    },
    downImg1: function downImg1() {
      var a = document.createElement('a'); //自定义a标签
      var event = new MouseEvent('click'); //自定义鼠标点击事件
      a.download = "".concat(this.customer_name_new, ",\u4E13\u5C5E\u5C0F\u7A0B\u5E8F\u94FE\u63A5.png");
      a.href = this.linkInfo.mini_program_img_base64;
      a.dispatchEvent(event);
    },
    watchCustomerName: function watchCustomerName() {
      var _this3 = this;
      var params = {
        id: this.customer_id
      };
      watchCompanyName(params).then(function (res) {
        _this3.customer_name_new = res.data.company_name;
      });
    }
  }
};